import {parseISO} from 'date-fns'
import {REQUEST_MILESTONE_NAME, RequestMilestone, RequestTagType} from '.'
import {RequestMilestone as VariationRequestMilestone} from './types.variation'
import {REQUEST_MILESTONE_NAME as VARIATION_REQUEST_MILESTONE_NAME } from './constants.variation'

export const getMilestone = (
  type: RequestMilestone | VariationRequestMilestone,
  milestones: any[]
): any => {
  const typeMilestones = milestones.filter(
    (milestone: any) => milestone.type === type
  )
  typeMilestones.sort((a, b) => +parseISO(b.createdAt) - +parseISO(a.createdAt))
  return typeMilestones[0]
}

export const isMilestonePassed = (
  type: RequestMilestone | VariationRequestMilestone,
  request: any
): boolean => {
  if (!request?.milestones?.length) return false
  const milestone = getMilestone(type, request.milestones)
  return milestone ? milestone.passed : false
}
export const isFirstManagerActionsChecked = (request: any): boolean =>
  isMilestonePassed('documents-checked', request) &&
  isMilestonePassed('properties-set', request) &&
  isMilestonePassed('loan-summary-added', request)

export const isAllMilestonesPassed = (request:any, nameList?:string[]) : boolean => (
  !!request?.milestones?.length && 
  !request.milestones.filter(
    (m:any) => !nameList ? true : nameList.includes(m.type)
  ).map(
    (m:any) => !!m.passed
  ).some(
    (x:boolean) => (x === false)
  )
)

export const getNameOfRequestMilestone = (
  type:RequestMilestone | VariationRequestMilestone, 
  tag:RequestTagType
) => (
  (tag === 'variation') ? VARIATION_REQUEST_MILESTONE_NAME[(type as VariationRequestMilestone)]
  :
  REQUEST_MILESTONE_NAME[(type as RequestMilestone)]
)
